import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Axios from "axios";
import moment from "moment";

//STYLES
import * as AddPodcastStyles from "../styles/addPodcast";

function AddPodcast(props) {
    const [file, setFile] = useState(null);
    const [audio, setAudio] = useState({
        filename: "",
        uuid: ""
    });
    const audioPlayer = useRef(null);
    const defaultValues = {
        values: {
            title: "",
            description: ""
        },
        valids: {
            title: false,
            file: false
        },
        wholeForm: false,
        touched: false,
        descriptionMax: 200,
        descriptionRemaining: 200
    };
    const [data, setData] = useState(defaultValues);
    const [modal, setModal] = useState({
        header: "",
        message: "",
        open: false
    });

    useEffect(() => {
        setData(defaultValues);
        setFile(null);
    }, [props.open]);

    function handleModalClose() {
        setModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    function onInputChange(e) {
        setFile(e.target.files[0]);
        console.log(e.target.files[0]);
        let isValid = false;
        if (e.target.files.length > 0) {
            isValid = true;
        }

        const valids = data.valids;
        valids["file"] = isValid;

        let isFormValid = false;
        if (data.valids.title && data.valids.file) {
            isFormValid = true;
        }

        setData((prevState) => {
            return { ...prevState, valids, wholeForm: isFormValid };
        });
    }

    function handleInputChange(event) {
        const { name, value } = event.target;

        const values = data.values;
        const valids = data.valids;
        values[name] = value;

        if (name == "title") {
            let isValid = false;
            if (value.length > 0) {
                isValid = true;
            }
            valids[name] = isValid;
        }

        let desRemaing = data.descriptionRemaining;
        if (name == "description") {
            desRemaing = data.descriptionMax - value.length;
        }

        let isFormValid = false;
        if (data.valids.title && data.valids.file) {
            isFormValid = true;
        }

        setData((prevState) => {
            return { ...prevState, values, valids, wholeForm: isFormValid, descriptionRemaining: desRemaing };
        });
    }

    function handleSubmitPodcast() {
        if (!data.wholeForm) {
            setData((prevState) => {
                return { ...prevState, touched: true };
            });
        } else {
            const checkData = {
                fileName: file.name,
                fileSize: file.size,
                fileType: file.type,
                title: data.values.title
            };

            Axios.post("/pods/podcastAdmin/checkFile", checkData).then((res) => {
                const firstData = res.data;
                if (firstData.failed == "Yes") {
                    setModal({ header: "Add Podcast", message: firstData.message, open: true });
                } else {
                    const uploadData = new FormData();
                    uploadData.append("title", data.values.title);
                    uploadData.append("description", data.values.description);

                    const uploadConfig = {
                        headers: {
                            "content-type": "multipart-form-data"
                        },
                        onUploadProgress: (data) => {
                            console.log(data.loaded);
                        }
                    };

                    uploadData.append("audio", file);
                    Axios.post("/pods/podcastAdmin/uploadFile", uploadData, uploadConfig)
                        .then((res) => {
                            const secondData = res.data;
                            console.log(secondData);
                            if (secondData.name == "MulterError") {
                                setModal({ header: "Add Podcast: Upload", message: secondData.message, open: true });
                            } else {
                                setAudio((prevState) => {
                                    return { ...prevState, filename: secondData.fileName, uuid: secondData.uuid };
                                });
                            }
                        })
                        .catch((err) => console.log(err));
                }
            });
        }
    }

    function handleAudioOnLoad() {
        if (audio.filename != "") {
            const formattedDuration = moment.utc(audioPlayer.current.duration * 1000).format("mm:ss");
            console.log(formattedDuration);
            const data = { uuid: audio.uuid, time: formattedDuration };
            Axios.post("/pods/podcastAdmin/updateTime", data)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "null") {
                        props.reload();
                        props.close();
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    return (
        <div>
            <Modal show={props.open} onHide={props.close}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Podcast</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>
                            <strong>Title:</strong>
                        </Form.Label>
                        <Form.Control
                            isInvalid={data.touched && !data.valids.title ? true : false}
                            type="text"
                            name="title"
                            value={data.values.title}
                            onChange={handleInputChange}
                        />
                        <Form.Control.Feedback type="invalid">Please enter a title!</Form.Control.Feedback>
                    </Form.Group>
                    <br />
                    <Form.Group>
                        <Form.Label>
                            <strong>Description:</strong>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="description"
                            value={data.values.description}
                            maxLength={data.descriptionMax}
                            onChange={handleInputChange}
                        />
                        <div style={AddPodcastStyles.descriptionCount}>{data.descriptionRemaining}</div>
                    </Form.Group>
                    <br />
                    <Form.Group>
                        <Form.Label>
                            <strong>Upload Podcast</strong>
                        </Form.Label>
                        <Form.Control
                            isInvalid={data.touched && !data.valids.file ? true : false}
                            type="file"
                            name="audio"
                            onChange={onInputChange}
                        />
                        <Form.Control.Feedback type="invalid">Please upload a file!</Form.Control.Feedback>
                        <strong>1 file only. File formats: .mp3, .m4a, .wav. Max 160MB</strong>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleSubmitPodcast}>Add</Button>
                    <Button onClick={props.close}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={modal.open} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
            <audio src={`/content/podCasts/${audio.filename}`} ref={audioPlayer} onLoadedMetadata={handleAudioOnLoad} />
        </div>
    );
}

export default AddPodcast;
